import DOMPurify from 'dompurify';
const API = process.env.REACT_APP_BACKEND_URL;

export const protectedFileUrl = value => {
  try { const url = new URL(value, API); return url.pathname.startsWith('/api/kb/files/') ? `${API}${url.pathname}${url.search}` : null; }
  catch { return null; }
};
export const fetchProtectedBlob = async url => {
  const response = await fetch(protectedFileUrl(url), { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }, cache: 'no-store' });
  if (!response.ok) throw new Error('Attachment unavailable or access locked');
  return URL.createObjectURL(await response.blob());
};
export const prepareMediaHtml = html => {
  const element = document.createElement('div');
  element.innerHTML = DOMPurify.sanitize(html || '', { ADD_TAGS: ['iframe'] });
  for (const node of element.querySelectorAll('[src],a[href]')) {
    const attr = node.tagName === 'A' ? 'href' : 'src'; const url = node.getAttribute(attr);
    if (protectedFileUrl(url)) { node.setAttribute(`data-kb-original-${attr}`, url); node.removeAttribute(attr); }
  }
  return element.innerHTML;
};
export const serializeMediaHtml = element => {
  const copy = element?.cloneNode(true); if (!copy) return '';
  for (const node of copy.querySelectorAll('[data-kb-original-src],[data-kb-original-href]')) {
    for (const attr of ['src', 'href']) if (node.hasAttribute(`data-kb-original-${attr}`)) {
      node.setAttribute(attr, node.getAttribute(`data-kb-original-${attr}`)); node.removeAttribute(`data-kb-original-${attr}`);
    }
  }
  return copy.innerHTML;
};
export const hydrateMedia = async (element, urls) => {
  for (const node of element.querySelectorAll('[data-kb-original-src],[data-kb-original-href]')) {
    const attr = node.hasAttribute('data-kb-original-src') ? 'src' : 'href'; const source = node.getAttribute(`data-kb-original-${attr}`);
    try { if (!urls.has(source)) urls.set(source, await fetchProtectedBlob(source)); if (node.isConnected) node.setAttribute(attr, urls.get(source)); }
    catch { node.setAttribute('title', 'Attachment unavailable or access locked'); }
  }
};